import {
    CREATE_ACCOUNT,
    CREATE_ACCOUNT_FAILURE,
    CREATE_ACCOUNT_SUCCESS,
} from 'store/actions/types';

export const createAccount = (payload) => {
    return {
        type: CREATE_ACCOUNT,
        payload: payload,
    };
};

export const createAccountFailure = (error) => {
    return {
        type: CREATE_ACCOUNT_FAILURE,
        payload: error,
    };
};

export const createAccountSuccess = (response) => {
    return {
        type: CREATE_ACCOUNT_SUCCESS,
        payload: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/createAccounts.js